const $ = jQuery;
const Accordion = {
  init: ()=> {
    $(".accordion-title").on("click", function(){
      const parent = $(this).parent();
      const content = parent.find(">.accordion-content");
      if(parent && parent.length > 0 && content && content.length > 0){
        if(parent.hasClass("active")){
          content.slideUp("0.4s");
          parent.removeClass("active")
        }else{
          content.slideDown("0.4s")
          parent.addClass("active")
        }
      }
    })
  }
}
export default Accordion